import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ConversationSplash } from "../../components/OlliLogo";
import { AUTH_PATHS } from "../../components/auth/signupState";

/**
 * Splash after sign-in and signup (design: screens/Welcome.tsx): plays once
 * (1.9s), then opens the dashboard. Rendered outside the app shell, so it
 * carries the `olli` scope class itself.
 */
export default function Welcome() {
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => navigate(AUTH_PATHS.dashboard, { replace: true }), 2300);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div role="status" aria-label="Opening Olli AI" className="olli flex min-h-screen items-center justify-center bg-ink bg-[image:var(--gradient-night)] font-sans">
      <ConversationSplash tone="black" className="w-[520px] max-w-[70%]" />
    </div>
  );
}
